import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "rounded-md bg-red-50 p-4 text-left mt-3" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm font-medium text-red-800" }
const _hoisted_10 = { class: "mt-6 pb-2 text-left" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "mt-2 pb-2 text-left" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mt-2 pb-2 text-left" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "mt-2 pb-2 text-left" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "mt-1" }
const _hoisted_23 = { class: "mt-2 pb-2 text-left" }
const _hoisted_24 = { class: "text-sm" }
const _hoisted_25 = { class: "mt-1" }
const _hoisted_26 = { class: "mt-2 pb-2 text-left" }
const _hoisted_27 = { class: "text-sm mr-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Enable notifications", -1)
const _hoisted_29 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }
const _hoisted_30 = ["disabled"]

import { computed, ref, onMounted } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import {
  XCircleIcon,
} from "@heroicons/vue/solid";
import { useStore } from "vuex";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStreamingBaseDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const streamerList = ref([
  {
    name: "",
    value: "-- Select Streamer --",
  }
]
)
const newStreamingForm = ref({
  operatorId: store.state.selectedOperator.operatorId,
  streamerId: "",
  streamingName: "",
  streamingDetail: "",
  playerThumbnailUrl: "",
  isActive: true,
});

const errorMessage = ref("");
const isWorking = ref(false);
const hasError = ref(false);

const createStreaming = () => {
  axios
    .post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/streaming`,
      newStreamingForm.value,
      {
        headers: {
          "x-cm-operator-id": store.state.selectedOperator.operatorId,
        },
      }
    )
    .then(({ data }) => {
      newStreamingForm.value = {
        operatorId: store.state.selectedOperator.operatorId,
        streamingName: "",
        streamerId: "",
        streamingDetail: "",
        playerThumbnailUrl: "",
        isActive: true,
      };
      console.log("🚀 ~ data", data);
      emit("submit");
      isWorking.value = false;
    })
};
onMounted(() => {
  refetch();
});

const refetch = async () => {
  await axios
    .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/streamers/list`, {
      operatorId: store.state.selectedOperator.operatorId,
    })
    .then((response) => {
      streamerList.value = (response.data.data.map((streamer: any) => ({
        name: streamer.id,
        value: streamer.name
      })))
      streamerList.value.unshift(
        {
          name: "",
          value: "-- Select Streamer --",
        })
    })
};
console.log("streamerList.value: ", streamerList.value)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[8] || (_cache[8] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.stream.streaming.create")), 1)
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(XCircleIcon), {
                              class: "h-5 w-5 text-red-400",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("h3", _hoisted_9, _toDisplayString(errorMessage.value), 1)
                          ])
                        ])
                      ], 512), [
                        [_vShow, hasError.value]
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("messages.stream.streaming.operatorId")), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newStreamingForm.value.operatorId) = $event)),
                            name: "operatorId",
                            id: "operatorId",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newStreamingForm.value.operatorId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("messages.stream.streaming.streamerId")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("select", {
                            id: "streamerId",
                            name: "streamerId",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newStreamingForm.value.streamerId) = $event)),
                            class: "capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(streamerList.value, (streamer) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: streamer.name,
                                value: streamer.name
                              }, _toDisplayString(streamer.value), 9, _hoisted_16))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, newStreamingForm.value.streamerId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("messages.stream.streaming.streamingName")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newStreamingForm.value.streamingName) = $event)),
                            name: "streamingName",
                            id: "streamingName",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newStreamingForm.value.streamingName]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("messages.stream.streaming.streamingDetail")), 1),
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newStreamingForm.value.streamingDetail) = $event)),
                            name: "streamingDetail",
                            id: "streamingDetail",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newStreamingForm.value.streamingDetail]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("messages.stream.streaming.playerThumbnailUrl")), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newStreamingForm.value.playerThumbnailUrl) = $event)),
                            name: "playerThumbnailUrl",
                            id: "playerThumbnailUrl",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, newStreamingForm.value.playerThumbnailUrl]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("messages.stream.streaming.isActive")), 1),
                        _createVNode(_unref(Switch), {
                          modelValue: newStreamingForm.value.isActive,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newStreamingForm.value.isActive) = $event)),
                          class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", newStreamingForm.value.isActive ? 'bg-blue-400' : 'bg-red-500'])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28,
                            _createElementVNode("span", {
                              class: _normalizeClass([newStreamingForm.value.isActive ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                            }, null, 2)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none sm:col-start-2 sm:text-sm", isWorking.value
                  ? 'bg-gray-500'
                  : ' bg-blue-600  hover:bg-blue-700  focus:ring-blue-500 focus:ring-2 focus:ring-offset-2'
                  ]),
                      disabled: isWorking.value,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (createStreaming()))
                    }, _toDisplayString(_ctx.$t("messages.stream.streaming.create")) + " " + _toDisplayString(_ctx.$t("messages.stream.streaming.topic")), 11, _hoisted_30),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('cancel'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                      ref: "cancelButtonRef"
                    }, " Cancel ", 512)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})